import { useRef, useState, useEffect } from 'react';
import DatePickerControl from "../../../Controls/DatePickerControl"
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import Accordion from 'react-bootstrap/Accordion';
import ButtonControl from "../../../Controls/ButtonControl"
import SelectControl from "../../../Controls/SelectControl"
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

import {
	GetLocal,
	FetchService,
	Base64Type,
	GetParamsUrl,
	ConvertCharacterDate
} from "../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

let selectOption = '';
let countList = 0;

export default function Index(props) {
	const navigate = useNavigate();
	const [getServiceResult, setServiceResult] = useState(false);
	const [getLandUseInfo, setLandUseInfo] = useState([]);
	const [getBuildingUsageInfo, setBuildingUsageInfo] = useState([]);
	const [getFacadeTypeInfo, setFacadeTypeInfo] = useState([]);
	const [getBuildingMaterialsInfo, setBuildingMaterialsInfo] = useState([]);
	const [getBuildingStageInfo, setBuildingStageInfo] = useState([]);
	const [getRoofTypeInfo, setRoofTypeInfo] = useState([]);
	const [getBuildingStructureInfo, setBuildingStructureInfo] = useState([]);
	const [getGeographicalDirectionInfo, setGeographicalDirectionInfo] = useState([]);
	const [getSupervisorEngineerInfo, setSupervisorEngineerInfo] = useState([]);
	const [getBuildingFloorInfo, setBuildingFloorInfo] = useState([]);
	const [getLimitTypeInfo, setLimitTypeInfo] = useState([]);
	const [getSecondaryUseTypeInfo, setSecondaryUseTypeInfo] = useState([]);
	const [getPrimaryUseTypeInfo, setPrimaryUseTypeInfo] = useState([]);
	const [getAllowedUsageInfoList, setAllowedUsageInfoList] = useState(false);
	const [getGetExistUsageInfoList, setGetExistUsageInfoList] = useState(false);

	const valueVisitorRef = useRef(null);
	const valueViewDateRef = useRef(null);
	const valueInspectionNumberRef = useRef(0);
	const valueLandUseRef = useRef(0);
	const valueBuildingUsageRef = useRef(0);
	const valueBuildingStructureRef = useRef(0);
	const valueParcelAreaRef = useRef(0);
	const valueBasementFloorCountRef = useRef(0);
	const valueFloorCountRef = useRef(0);
	const valueBuildingStageCodeRef = useRef(0);
	const valueFirstReviewValueRef = useRef(0);
	const valueSecondReviewValueRef = useRef(0);
	const valueThirdReviewValueRef = useRef(0);
	const valueFourthReviewValueRef = useRef(0);
	const valueContradictionStatusRef = useRef(null);
	const valueLastConstructNumberRef = useRef(0);
	const valueLastNonContradictionNumberRef = useRef(0);
	const valueLastCompletionNumberRef = useRef(0);
	const valueLastConstructDateRef = useRef(null);
	const valueLastNonContradictionDateRef = useRef(null);
	const valueLastCompletionDateRef = useRef(null);
	const valueBuildingYearRef = useRef(null);
	const valueBuildingMaterialsRef = useRef(0);
	const valueSupervisorEngineerRef = useRef(0);
	const valueReviewDescriptionRef = useRef(null);
	const valueFacadeTypeInfoRef = useRef(0);
	const valueRoofTypeInfoRef = useRef(0);

	const DimentionDetailsInfoListRef = useRef([]);

	const valueUnitRef = useRef(null);
	const valueAreaRef = useRef(null);
	const valueEntryNumberRef = useRef(null);
	const valueEntryLengthRef = useRef(null);
	const valueEntryHeightRef = useRef(null);

	const valueUnit1Ref = useRef(null);
	const valueArea1Ref = useRef(null);
	const valueEntryNumber1Ref = useRef(null);
	const valueEntryLength1Ref = useRef(null);
	const valueEntryHeight1Ref = useRef(null);

	useEffect(() => {
		document.querySelectorAll('.accordion-header button').forEach((item) => {
			item.addEventListener('click', (e) => {
				document.getElementsByTagName('body')[0].scrollTo(0, 0);
			});
		});

		GetAbstractList('ShowLandUseAbstractList');
		GetAbstractList('ShowBuildingUsageAbstractList');
		GetAbstractList('ShowFacadeTypeAbstractList');
		GetAbstractList('ShowBuildingStageAbstractList');
		GetAbstractList('ShowBuildingMaterialsAbstractList');
		GetAbstractList('ShowRoofTypeAbstractList');
		GetAbstractList('ShowBuildingStructureAbstractList');
		GetAbstractList('ShowSupervisorEngineerAbstractList');
		GetAbstractList('ShowGeographicalDirectionAbstractList');
		GetAbstractList('ShowLimitTypeAbstractList');
		GetAbstractList('ShowBuildingFloorAbstractList');
		GetAbstractList('ShowPrimaryUsedTypeAbstractList');
		//GetAbstractList('ShowSecondaryUsedTypeAbstractList');		

		GetReviewReportFetch();
	}, []);

	const GetReviewReportFetch = () => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: GetLocal('FileNumber')
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetReviewReportFetch", inputValue, GetReviewReportFetchSuccess);
	}

	const GetReviewReportFetchSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);

		valueVisitorRef.current.value = ServiceResult.Visitor;
		valueViewDateRef.current.value = ServiceResult.ViewDate;
		valueInspectionNumberRef.current.value = ServiceResult.InspectionNumber;
		valueLandUseRef.current.value = ServiceResult.LandUseCode;
		valueBuildingUsageRef.current.value = ServiceResult.BuildingUsageCode;
		valueBuildingStructureRef.current.value = ServiceResult.BuildingStructureCode;
		valueParcelAreaRef.current.value = ServiceResult.ParcelArea;
		valueBasementFloorCountRef.current.value = ServiceResult.BasementFloorCount;
		valueFloorCountRef.current.value = ServiceResult.FloorCount;
		valueBuildingStageCodeRef.current.value = ServiceResult.BuildingStageCode;

		valueContradictionStatusRef.current.value = ServiceResult.ContradictionStatus;
		valueLastConstructNumberRef.current.value = ServiceResult.LastConstructNumber;
		valueLastNonContradictionNumberRef.current.value = ServiceResult.LastNonContradictionNumber;
		valueLastCompletionNumberRef.current.value = ServiceResult.LastCompletionNumber;
		valueLastConstructDateRef.current.value = ServiceResult.LastConstructDate;
		valueLastNonContradictionDateRef.current.value = ServiceResult.LastNonContradictionDate;
		valueLastCompletionDateRef.current.value = ServiceResult.LastCompletionDate;
		valueBuildingYearRef.current.value = ServiceResult.BuildingYear;
		valueBuildingMaterialsRef.current.value = ServiceResult.BuildingMaterialsCode;
		valueSupervisorEngineerRef.current.value = ServiceResult.SupervisorEngineerCode;
		valueReviewDescriptionRef.current.value = ServiceResult.ReviewDescription;
	}

	const ShowReviewDetailSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
	}

	const GetAbstractList = (urlService) => {
		var inputValue = {
			session: GetLocal('EmployeeSession')
		};
		FetchService("Employee/Abstract/" + urlService, inputValue, GetAbstractListSuccess);
	}

	const GetAbstractListSuccess = (ServiceResult) => {
		if (ServiceResult.LandUseInfo)
			setLandUseInfo(ServiceResult.LandUseInfo);
		if (ServiceResult.BuildingUsageInfo)
			setBuildingUsageInfo(ServiceResult.BuildingUsageInfo);
		if (ServiceResult.FacadeTypeInfo)
			setFacadeTypeInfo(ServiceResult.FacadeTypeInfo);
		if (ServiceResult.BuildingMaterialsInfo)
			setBuildingMaterialsInfo(ServiceResult.BuildingMaterialsInfo);
		if (ServiceResult.BuildingStageInfo)
			setBuildingStageInfo(ServiceResult.BuildingStageInfo);
		if (ServiceResult.RoofTypeInfo)
			setRoofTypeInfo(ServiceResult.RoofTypeInfo);
		if (ServiceResult.BuildingStructureInfo)
			setBuildingStructureInfo(ServiceResult.BuildingStructureInfo);
		if (ServiceResult.GeographicalDirectionInfo)
			setGeographicalDirectionInfo(ServiceResult.GeographicalDirectionInfo);
		if (ServiceResult.SupervisorEngineerInfo)
			setSupervisorEngineerInfo(ServiceResult.SupervisorEngineerInfo);
		if (ServiceResult.BuildingFloorInfo)
			setBuildingFloorInfo(ServiceResult.BuildingFloorInfo);
		if (ServiceResult.LimitTypeInfo)
			setLimitTypeInfo(ServiceResult.LimitTypeInfo);
		if (ServiceResult.SecondaryUseTypeInfo)
			setSecondaryUseTypeInfo(ServiceResult.SecondaryUseTypeInfo);
		if (ServiceResult.PrimaryUseTypeInfo)
			setPrimaryUseTypeInfo(ServiceResult.PrimaryUseTypeInfo);
	}

	const SaveReviewReport = () => {
		let dimentionDetailsInfoArray = [];
		let allowedUsageInfoArray = [];
		let existUsageInfoArray = [];
		let differenceUsageInfoArray = [];

		document.querySelectorAll("#DimentionDetailsInfoList tbody tr").forEach((item, i) => {
			if (i != 0) {
				let dimentionDetailsInfoObject = {
					"dimensionsSide": item.querySelectorAll("td")[0].querySelector('input,select').value,
					"lengthSide": item.querySelectorAll("td")[1].querySelector('input,select').value,
					"limitCode": item.querySelectorAll("td")[2].querySelector('input,select').value,
					"crossWidth": item.querySelectorAll("td")[3].querySelector('input,select').value,
					"streetName": item.querySelectorAll("td")[4].querySelector('input,select').value,
					"description": item.querySelectorAll("td")[5].querySelector('input,select').value
				}
				dimentionDetailsInfoArray.push(dimentionDetailsInfoObject);
			}
		});

		document.querySelectorAll("#AllowedUsageInfoList tbody tr").forEach((item, i) => {
			if (i != 0 && item.style.display == '') {
				let allowedUsageInfoObject = {
					"floorCode": item.querySelectorAll("td")[1].querySelector('input,select').value,
					"primaryUsedType": item.querySelectorAll("td")[2].querySelector('input,select').value,
					"secondaryUsedType": item.querySelectorAll("td")[3].querySelector('input,select').value,
					"unit": item.querySelectorAll("td")[4].querySelector('input,select').value,
					"area": item.querySelectorAll("td")[5].querySelector('input,select').value,
					"entryNumber": item.querySelectorAll("td")[6].querySelector('input,select').value,
					"entryLength": item.querySelectorAll("td")[7].querySelector('input,select').value,
					"entryHeight": item.querySelectorAll("td")[8].querySelector('input,select').value
				}
				allowedUsageInfoArray.push(allowedUsageInfoObject);
			}
		});

		document.querySelectorAll("#ExistUsageInfoList tbody tr").forEach((item, i) => {
			if (i != 0 && item.style.display == '') {
				let existUsageInfoObject = {
					"floorCode": item.querySelectorAll("td")[1].querySelector('input,select').value,
					"primaryUsedType": item.querySelectorAll("td")[2].querySelector('input,select').value,
					"secondaryUsedType": item.querySelectorAll("td")[3].querySelector('input,select').value,
					"unit": item.querySelectorAll("td")[4].querySelector('input,select').value,
					"area": item.querySelectorAll("td")[5].querySelector('input,select').value,
					"entryNumber": item.querySelectorAll("td")[6].querySelector('input,select').value,
					"entryLength": item.querySelectorAll("td")[7].querySelector('input,select').value,
					"entryHeight": item.querySelectorAll("td")[8].querySelector('input,select').value
				}
				existUsageInfoArray.push(existUsageInfoObject);
			}
		});

		/*document.querySelectorAll("#DifferenceUsageInfoList tbody tr").forEach((item,i)=>{
			if(i!=0){
				let differenceUsageInfoObject = {
				  "row": item.querySelectorAll("td")[0].innerHTML,
				  "floorCode": item.querySelectorAll("td")[1].innerHTML,
				  "floorTitle": item.querySelectorAll("td")[2].innerHTML,
				  "primaryUsedType": item.querySelectorAll("td")[3].innerHTML,
				  "primaryUsedTitle": item.querySelectorAll("td")[4].innerHTML,
				  "secondaryUsedType": item.querySelectorAll("td")[5].innerHTML,
				  "secondaryUsedTitle": 0,
				  "unit": 0,
				  "area": 0
				}	
				differenceUsageInfoArray.push(differenceUsageInfoObject);  	
			}
		});	*/

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: GetLocal('FileNumber'),
			supervisorEngineerCode: valueSupervisorEngineerRef.current.value,
			parcelArea: valueParcelAreaRef.current.value,
			reviewDate: ConvertCharacterDate(valueViewDateRef.current.firstChild.defaultValue),
			landUseCode: valueLandUseRef.current.value,
			buildingUsageCode: valueBuildingUsageRef.current.value,
			buildingStageCode: valueBuildingStageCodeRef.current.value,
			buildingStructureCode: valueBuildingStructureRef.current.value,
			buildingMaterialsCode: valueBuildingMaterialsRef.current.value,
			basementFloorCount: valueBasementFloorCountRef.current.value,
			floorCount: valueFloorCountRef.current.value,
			buildingYear: valueBuildingYearRef.current.value,
			lastConstructNumber: valueLastConstructNumberRef.current.value,
			lastNonContradictionNumber: valueLastNonContradictionNumberRef.current.value,
			lastCompletionNumber: valueLastCompletionNumberRef.current.value,
			lastConstructDate: ConvertCharacterDate(valueLastConstructDateRef.current.firstChild.defaultValue),
			lastNonContradictionDate: ConvertCharacterDate(valueLastNonContradictionDateRef.current.firstChild.defaultValue),
			lastCompletionDate: ConvertCharacterDate(valueLastCompletionDateRef.current.firstChild.defaultValue),
			reviewDescription: valueReviewDescriptionRef.current.value,
			contradictionStatus: valueContradictionStatusRef.current.value == "true" ? true : false,
			firstReviewValue: valueFirstReviewValueRef.current.value == "" ? 0 : valueFirstReviewValueRef.current.value,
			secondReviewValue: valueSecondReviewValueRef.current.value == "" ? 0 : valueSecondReviewValueRef.current.value,
			thirdReviewValue: valueThirdReviewValueRef.current.value,
			fourthReviewValue: valueFourthReviewValueRef.current.value,
			facadeType: valueFacadeTypeInfoRef.current.value,
			roofType: valueRoofTypeInfoRef.current.value,
			dimentionDetailsInfoList: dimentionDetailsInfoArray,
			allowedUsageInfoList: allowedUsageInfoArray,
			existUsageInfoList: existUsageInfoArray,
			differenceUsageInfoList: differenceUsageInfoArray
		}

		EmployeeSessionCheckFetch("Employee/Urbanization/Request/SaveReviewReport", inputValue, SaveReviewReportSuccess);
	}

	const SaveReviewReportSuccess = (ServiceResult) => {
		toast.success("اطلاعات با موفقیت ثبت گردید");
		GetReviewReportFetch()
		// window.location = "/Employee/ShowReviewDetailEmployee?page=جزییات گزارش بازدید";
		//navigate("/SubmitRequest");
	}

	/*const CloseAccordion=(value)=>{
		document.getElementsByTagName('body')[0].scrollTo(0, 0);
		document.querySelectorAll('.accordion-button')[value].click()
	}*/

	const ShowSecondaryUsedTypeAbstractList = (value, e) => {
		selectOption = e.target.parentNode.parentNode.parentNode.querySelectorAll('select')[2]
		selectOption.innerHTML = "";

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			primaryUseTypeID: value
		};
		FetchService("Employee/Abstract/ShowSecondaryUsedTypeAbstractList", inputValue, ShowSecondaryUsedTypeAbstractListSuccess);
	}

	const ShowSecondaryUsedTypeAbstractListSuccess = (ServiceResult) => {
		ServiceResult.SecondaryUseTypeInfo.forEach((item) => {
			let option = document.createElement("option");
			option.text = item.Title;
			option.value = item.ID;
			selectOption.appendChild(option);
		});
	}

	const ContradictionStatusradio = (value) => {
		valueContradictionStatusRef.current.value = value === 1;
	}

	useEffect(() => {
		ChnageShowSecondaryUsedTypeAbstractList();

	}, [getServiceResult, getAllowedUsageInfoList]);

	const ChnageShowSecondaryUsedTypeAbstractList = () => {
		document.querySelectorAll('.ShowSecondaryUsedTypeAbstractList').forEach((item) => {
			item.addEventListener("change", function (e) {
				ShowSecondaryUsedTypeAbstractList(e.target.value, e);
			});
		});
	}

	const AddRowClick = async (id) => {

		if (id == 'AllowedUsageInfoList') {
			if (document.querySelectorAll("#" + id + " tbody tr").length == 1) {
				await setAllowedUsageInfoList(true);
			}
			else {
				const tbody = document.querySelector("#" + id + " tbody");

				tbody.insertAdjacentHTML(
					'beforeend',
					tbody.querySelectorAll("tr")[1].innerHTML
				);

				const newRow = tbody.lastElementChild;

				const secondarySelect = newRow.querySelectorAll("select")[2];

				secondarySelect.innerHTML = null;

				const option = document.createElement("option");
				option.value = null;
				option.text = "انتخاب کنید";
				option.selected = true;
				secondarySelect.appendChild(option);

				// Clear all selects
				newRow.querySelectorAll("select").forEach(select => {
					select.selectedIndex = null;
				});

				// Clear textboxes
				newRow.querySelectorAll("input[type='text'], input[type='number']").forEach(input => {
					input.value = "0";
				});

				// Uncheck checkboxes
				newRow.querySelectorAll("input[type='checkbox']").forEach(chk => {
					chk.checked = false;
				});
			}
		}

		if (id == 'ExistUsageInfoList') {
			if (document.querySelectorAll("#" + id + " tbody tr").length == 1) {
				await setGetExistUsageInfoList(true);
			}
			else {
				const tbody = document.querySelector("#" + id + " tbody");

				tbody.insertAdjacentHTML(
					'beforeend',
					tbody.querySelectorAll("tr")[1].innerHTML
				);

				const newRow = tbody.lastElementChild;
				const secondarySelect = newRow.querySelectorAll("select")[2];

				secondarySelect.innerHTML = null;

				const option = document.createElement("option");
				option.value = null;
				option.text = "انتخاب کنید";
				option.selected = true;
				secondarySelect.appendChild(option);

				// Clear all selects
				newRow.querySelectorAll("select").forEach(select => {
					select.selectedIndex = null;
				});

				// Clear textboxes
				newRow.querySelectorAll("input[type='text'], input[type='number']").forEach(input => {
					input.value = "0";
				});

				// Uncheck checkboxes
				newRow.querySelectorAll("input[type='checkbox']").forEach(chk => {
					chk.checked = false;
				});
			}
		}


		ChnageShowSecondaryUsedTypeAbstractList();
	}

	const RemoveRowClick = async (id) => {
		document.querySelectorAll("#" + id + " tbody tr").forEach((item, i) => {
			if (i != 0) {
				if (item.querySelectorAll('td input')[0].checked) {
					item.style.display = "none";
				}
			}
		});
	}

	const ShowSecondaryUsedTypeAbstractListAccordion = (value, e) => {
		selectOption = e.parentNode.parentNode.parentNode.querySelectorAll('select')[2]

		selectOption.innerHTML = "";
		var inputValue = {
			primaryUseTypeID: value,
			session: GetLocal('EmployeeSession'),
		};
		FetchService("Employee/Abstract/ShowSecondaryUsedTypeAbstractList", inputValue, ShowSecondaryUsedTypeAbstractListAccordionSuccess);
	}

	const ShowSecondaryUsedTypeAbstractListAccordionSuccess = (ServiceResult) => {

		let idSelect = document.querySelectorAll('.ShowSecondaryUsedTypeAbstractList')[countList - 1].getAttribute('dataValue')

		ServiceResult.SecondaryUseTypeInfo.forEach((item) => {
			let option = document.createElement("option");
			option.text = item.Title;
			option.value = item.ID;
			if (Number(idSelect) == item.ID)
				option.selected = "selected";
			selectOption.appendChild(option);
		});

		if (countList > 1)
			EventKeyListAccordion(--countList)
	}

	const EventKeyListAccordion = (value) => {
		if (document.querySelectorAll('.ShowSecondaryUsedTypeAbstractList')[countList] != undefined) {
			if (value == 0)
				countList = document.querySelectorAll('.ShowSecondaryUsedTypeAbstractList').length;
			ShowSecondaryUsedTypeAbstractListAccordion(document.querySelectorAll('.ShowSecondaryUsedTypeAbstractList')[countList - 1].options.selectedIndex, document.querySelectorAll('.ShowSecondaryUsedTypeAbstractList')[countList - 1])
		}
	}

	return (
		<div class="text-right my-4">
			<Accordion>
				<Accordion.Item eventKey="0">
					<Accordion.Header>اطلاعات اصلی</Accordion.Header>
					<Accordion.Body>
						<table id="BasicInfo" className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
							<tbody>
								<tr>
									<td colspan="3" className="text-right"><b class="b1">مامور بازدید:</b><TextBoxControl disabled={true} inputRef={valueVisitorRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">تاریخ بازدید:</b><DatePickerControl value={getServiceResult.ViewDate} inputRef={valueViewDateRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">نوبت بازدید:</b><TextBoxControl disabled={true} inputRef={valueInspectionNumberRef} /></td>
								</tr>
								<tr>
									<td colspan="3" className="text-right"><b class="b1"> نوع زمین: </b><SelectControl data={getLandUseInfo} inputRef={valueLandUseRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">مرحله ساختمانی:  </b><SelectControl data={getBuildingStageInfo} inputRef={valueBuildingStageCodeRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">نوع اسکلت: </b><SelectControl data={getBuildingStructureInfo} inputRef={valueBuildingStructureRef} /></td>
								</tr>
								<tr>
									<td colspan="3" className="text-right"><b class="b1">مساحت زمین: </b><TextBoxControl inputRef={valueParcelAreaRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">تعداد طبقات زیر زمین: </b><TextBoxControl inputRef={valueBasementFloorCountRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">تعداد طبقات سایر: </b><TextBoxControl inputRef={valueFloorCountRef} /></td>
								</tr>
								<tr>
									<td colspan="3" className="text-right"><b class="b1">وضعیت ساختمان: </b><SelectControl data={getBuildingUsageInfo} inputRef={valueBuildingUsageRef} /></td>
									{getServiceResult.IsDisplayableFirstReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.FirstReviewTitle}: </b><TextBoxControl value={getServiceResult.FirstReviewValue} inputRef={valueFirstReviewValueRef} /></td>}
									{getServiceResult.IsDisplayableSecondReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.SecondReviewTitle}: </b><TextBoxControl value={getServiceResult.SecondReviewValue} inputRef={valueSecondReviewValueRef} /></td>}
								</tr>
								<tr>
									{getServiceResult.IsDisplayableThirdReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.ThirdReviewTitle}: </b><TextBoxControl value={getServiceResult.ThirdReviewValue} inputRef={valueThirdReviewValueRef} /></td>}
									{getServiceResult.IsDisplayableFourthReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.FourthReviewTitle}: </b><TextBoxControl value={getServiceResult.FourthReviewValue} inputRef={valueFourthReviewValueRef} /> </td>}
									<td colspan="3" className="text-right"><b class="b1">وضعیت خلاف: </b>
										<input onClick={() => ContradictionStatusradio(1)} ref={valueContradictionStatusRef} type="radio" name="handleStep" checked={valueContradictionStatusRef != false} /> دارد &nbsp;&nbsp;&nbsp;
										<input onClick={() => ContradictionStatusradio(0)} ref={valueContradictionStatusRef} type="radio" name="handleStep" checked={valueContradictionStatusRef != true} />	ندارد
									</td>
								</tr>
								<tr>
									<td colspan="3" className="text-right"><b class="b1">شماره آخرین پروانه: </b><TextBoxControl inputRef={valueLastConstructNumberRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">شماره آخرین عدم خلاف: </b><TextBoxControl inputRef={valueLastNonContradictionNumberRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">شماره آخرین پایانکار: </b><TextBoxControl inputRef={valueLastCompletionNumberRef} /></td>
								</tr>
								<tr>
									<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین پروانه: </b><DatePickerControl value={getServiceResult.LastConstructDate} inputRef={valueLastConstructDateRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین عدم خلاف: </b><DatePickerControl value={getServiceResult.LastNonContradictionDate} inputRef={valueLastNonContradictionDateRef} /> </td>
									<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین پایان کار: </b><DatePickerControl value={getServiceResult.LastCompletionDate} inputRef={valueLastCompletionDateRef} /></td>
								</tr>
								<tr>
									<td colspan="3" className="text-right"><b class="b1">سال ساخت  بنا: </b><TextBoxControl value={getServiceResult.BuildingYear} inputRef={valueBuildingYearRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">مصالح ساختمانی: </b><SelectControl data={getBuildingMaterialsInfo} inputRef={valueBuildingMaterialsRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">مهندس ناظر: </b><SelectControl data={getSupervisorEngineerInfo} inputRef={valueSupervisorEngineerRef} /></td>
								</tr>
								<tr>
									<td colspan="3" className="text-right"><b class="b1">نوع نما: </b><SelectControl data={getFacadeTypeInfo} inputRef={valueFacadeTypeInfoRef} /></td>
									<td colspan="3" className="text-right"><b class="b1">نوع سقف: </b><SelectControl data={getRoofTypeInfo} inputRef={valueRoofTypeInfoRef} /></td>
								</tr>
								<tr>
									<td colspan="9" className="text-right"><b class="b1">  توضیحات بازدید:</b> <br /><TextBoxControl inputRef={valueReviewDescriptionRef} /> </td>
								</tr>
							</tbody>
						</table>
					</Accordion.Body>
				</Accordion.Item>
				<Accordion.Item eventKey="1">
					<Accordion.Header>اطلاعات جهت و ابعاد ملک</Accordion.Header>
					<Accordion.Body>
						<table id="DimentionDetailsInfoList" className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
							<tbody>
								<tr>
									<td colspan="1" className="text-center"><b class="b1">جهت</b></td>
									<td colspan="1" className="text-center"><b class="b1">طول ضلع</b></td>
									<td colspan="1" className="text-center"><b class="b1">حد</b></td>
									<td colspan="1" className="text-center"><b class="b1">عرض گذر</b></td>
									<td colspan="1" className="text-center"><b class="b1">نام معبر</b></td>
									<td colspan="1" className="text-center"><b class="b1">پخ و قوس</b></td>
								</tr>
								{getServiceResult.DimentionDetailsInfoList && getServiceResult.DimentionDetailsInfoList.map((item, i) => (
									<tr>
										<td colspan="1" className="text-center"><SelectControl data={getGeographicalDirectionInfo} selected={item.DimensionsSide} /></td>
										<td colspan="1" className="text-center"><TextBoxControl value={item.LengthSide} /></td>
										<td colspan="1" className="text-center"><SelectControl data={getLimitTypeInfo} selected={item.LimitCode} /></td>
										<td colspan="1" className="text-center"><TextBoxControl value={item.CrossWidth} /></td>
										<td colspan="1" className="text-center"><TextBoxControl value={item.StreetName} /></td>
										<td colspan="1" className="text-center"><TextBoxControl value={item.Description} /></td>
									</tr>
								))}
							</tbody>
						</table>
					</Accordion.Body>
				</Accordion.Item>
				<Accordion.Item eventKey="2">
					<Accordion.Header onClick={() => EventKeyListAccordion(0)}>اطلاعات بناهای موجود و مجاز</Accordion.Header>
					<Accordion.Body className="responseTable">
						<p class="text-primary">وضع موجود:</p>
						<table id="ExistUsageInfoList" className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
							<tbody>
								<tr>
									<td colspan="3" className="text-center"><b class="b1">#</b></td>
									<td width="170" colspan="3" className="text-center"><b class="b1">طبقه</b></td>
									<td width="200" colspan="3" className="text-center"><b class="b1">نوع استفاده اصلی</b></td>
									<td width="200" colspan="3" className="text-center"><b class="b1">نوع استفاده فرعی</b></td>
									<td colspan="3" className="text-center"><b class="b1">واحد</b></td>
									<td colspan="3" className="text-center"><b class="b1">مساحت</b></td>
									<td colspan="3" className="text-center"><b class="b1">تعداد دهانه</b></td>
									<td colspan="3" className="text-center"><b class="b1">طول دهانه</b></td>
									<td colspan="3" className="text-center"><b class="b1">ارتفاع دهانه</b></td>
								</tr>
								{getServiceResult.ExistUsageInfoList && getServiceResult.ExistUsageInfoList.map((item, index) => (
									<tr key={index}>
										<td colspan="3" className="text-center"><input style={{ verticalAlign: 'text-bottom' }} type="checkbox" name="checkbox" /></td>
										<td colspan="3" className="text-center"><SelectControl selected={item.FloorCode} data={getBuildingFloorInfo} /></td>
										<td colspan="3" className="text-center"><SelectControl dataValue={item.SecondaryUsedType} className="ShowSecondaryUsedTypeAbstractList" selected={item.PrimaryUsedType} data={getPrimaryUseTypeInfo} /></td>
										<td colspan="3" className="text-center"><SelectControl selected={item.SecondaryUsedType} data={getSecondaryUseTypeInfo} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.Unit || 0} inputRef={valueUnitRef} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.Area || 0} inputRef={valueAreaRef} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.EntryNumber || 0} inputRef={valueEntryNumberRef} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.EntryLength || 0} inputRef={valueEntryLengthRef} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.EntryHeight || 0} inputRef={valueEntryHeightRef} /></td>
									</tr>
								))}
								{getGetExistUsageInfoList &&
									<tr>
										<td colspan="3" className="text-center"><input style={{ verticalAlign: 'text-bottom' }} type="checkbox" name="checkbox" /></td>
										<td colspan="3" className="text-center"><SelectControl data={getBuildingFloorInfo} /></td>
										<td colspan="3" className="text-center"><SelectControl className="ShowSecondaryUsedTypeAbstractList" data={getPrimaryUseTypeInfo} /></td>
										<td colspan="3" className="text-center"><SelectControl data={getSecondaryUseTypeInfo} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
									</tr>
								}
							</tbody>
						</table>
						<div className="text-end d-flex">
							<ButtonControl
								onClick={() => AddRowClick('ExistUsageInfoList')}
								variant="primary"
								title="افزودن"
							/>
							<ButtonControl
								onClick={() => RemoveRowClick('ExistUsageInfoList')}
								variant="danger"
								className="mx-2"
								title="حذف"
							/>
						</div>
						<br />
						<p class="text-primary">وضع مجاز:</p>
						<table id="AllowedUsageInfoList" className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
							<tbody>
								<tr>
									<td colspan="3" className="text-center"><b class="b1">#</b></td>
									<td width="170" colspan="3" className="text-center"><b class="b1">طبقه</b></td>
									<td width="200" colspan="3" className="text-center"><b class="b1">نوع استفاده اصلی</b></td>
									<td width="200" colspan="3" className="text-center"><b class="b1">نوع استفاده فرعی</b></td>
									<td colspan="3" className="text-center"><b class="b1">واحد</b></td>
									<td colspan="3" className="text-center"><b class="b1">مساحت</b></td>
									<td colspan="3" className="text-center"><b class="b1">تعداد دهانه</b></td>
									<td colspan="3" className="text-center"><b class="b1">طول دهانه</b></td>
									<td colspan="3" className="text-center"><b class="b1">ارتفاع دهانه</b></td>
								</tr>
								{getServiceResult.AllowedUsageInfoList && getServiceResult.AllowedUsageInfoList.map((item) => (
									<tr>
										<td colspan="3" className="text-center"><input style={{ verticalAlign: 'text-bottom' }} type="checkbox" name="checkbox" /></td>
										<td colspan="3" className="text-center"><SelectControl selected={item.FloorCode} data={getBuildingFloorInfo} /></td>
										<td colspan="3" className="text-center"><SelectControl dataValue={item.SecondaryUsedType} className="ShowSecondaryUsedTypeAbstractList" selected={item.PrimaryUsedType} data={getPrimaryUseTypeInfo} /></td>
										<td colspan="3" className="text-center"><SelectControl selected={item.SecondaryUsedType} data={getSecondaryUseTypeInfo} /></td>

										<td colspan="3" className="text-center"><TextBoxControl value={item.Unit} inputRef={valueUnit1Ref} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.Area} inputRef={valueArea1Ref} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.EntryNumber} inputRef={valueEntryNumber1Ref} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.EntryLength} inputRef={valueEntryLength1Ref} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value={item.EntryHeight} inputRef={valueEntryHeight1Ref} /></td>
									</tr>
								))}
								{getAllowedUsageInfoList &&
									<tr>
										<td colspan="3" className="text-center"><input style={{ verticalAlign: 'text-bottom' }} type="checkbox" name="checkbox" /></td>
										<td colspan="3" className="text-center"><SelectControl data={getBuildingFloorInfo} /></td>
										<td colspan="3" className="text-center"><SelectControl className="ShowSecondaryUsedTypeAbstractList" data={getPrimaryUseTypeInfo} /></td>
										<td colspan="3" className="text-center"><SelectControl data={getSecondaryUseTypeInfo} /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
										<td colspan="3" className="text-center"><TextBoxControl value="0" /></td>
									</tr>
								}
							</tbody>
						</table>
						<div className="text-end d-flex">
							<ButtonControl
								onClick={() => AddRowClick('AllowedUsageInfoList')}
								variant="primary"
								title="افزودن"
							/>
							<ButtonControl
								onClick={() => RemoveRowClick('AllowedUsageInfoList')}
								variant="danger"
								className="mx-2"
								title="حذف"
							/>
						</div>
						<br />
						<p class="text-primary">اختلاف وضع موجود و مجاز:</p>
						<table id="DifferenceUsageInfoList" className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
							<tbody>
								<tr>
									<td colspan="3" className="text-center"><b class="b1">ردیف</b></td>
									<td colspan="3" className="text-center"><b class="b1">طبقه</b></td>
									<td colspan="3" className="text-center"><b class="b1">نوع استفاده اصلی</b></td>
									<td colspan="3" className="text-center"><b class="b1">نوع استفاده فرعی</b></td>
									<td colspan="3" className="text-center"><b class="b1">واحد</b></td>
									<td colspan="3" className="text-center"><b class="b1">مساحت</b></td>
								</tr>
								{getServiceResult.DifferenceUsageInfoList && getServiceResult.DifferenceUsageInfoList.map((item) => (
									<tr>
										<td colspan="3" className="text-center">{item.Row}</td>
										<td colspan="3" className="text-center">{item.FloorTitle}</td>
										<td colspan="3" className="text-center">{item.PrimaryUsedTitle}</td>
										<td colspan="3" className="text-center">{item.SecondaryUsedTitle}</td>
										<td colspan="3" className="text-center">{item.Unit}</td>
										<td dir="ltr" colspan="3" className="text-center">{item.Area}</td>
									</tr>
								))}
							</tbody>
						</table>
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>
			<br />
			<div className="text-end">
				<ButtonControl
					onClick={SaveReviewReport}
					variant="success"
					title="ثبت اطلاعات"
					icon="fa fa-plus"
				/>
			</div>
		</div>
	);
}
